import React from 'react';
import { SupplierPaymentModalView } from './SupplierPaymentModalView';
import {
    useSupplierPaymentForm,
    type SupplierPaymentInvoiceOption,
    type SupplierPaymentSubmit,
} from './useSupplierPaymentForm';

type SupplierPaymentModalProps = {
    error: string | null;
    /** The supplier's open invoices, offered as allocation targets. */
    invoices: SupplierPaymentInvoiceOption[];
    isOpen: boolean;
    isSubmitting: boolean;
    onClose: () => void;
    onSubmit: (input: SupplierPaymentSubmit) => void;
    supplierName: string;
    /** Today, ISO `YYYY-MM-DD`. Injected so the boundary is testable. */
    today: string;
};

/**
 * Container for the Record Payment modal: instantiates the form-state hook and
 * hands its output (plus the modal chrome) to the render-only View.
 */
export const SupplierPaymentModal: React.FC<SupplierPaymentModalProps> = ({
    error,
    invoices,
    isOpen,
    isSubmitting,
    onClose,
    onSubmit,
    supplierName,
    today,
}) => {
    const form = useSupplierPaymentForm({ isOpen, today, onSubmit });

    return (
        <SupplierPaymentModalView
            error={error}
            form={form}
            invoices={invoices}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            onClose={onClose}
            supplierName={supplierName}
            today={today}
        />
    );
};
